import { DiscountScope as DiscountScopeNew } from '../plugins/commonTypes/ProductTypes';
import { calculateVat } from '../vatRates/VatRatesMgr';
const calculateSimpleDiscountFixedAmount = ({ price, discount, isMenu }) => {
    if (!isNaN(discount.discountValue) && typeof discount.discountValue === 'number') {
        const discountedPrice = price * 100 - discount.discountValue * 100;
        if (isMenu) {
            return discountedPrice / 100;
        }
        return discountedPrice >= 0 ? discountedPrice / 100 : price;
    }
    return price;
};
const calculatePercentDiscountAmount = ({ price, discount }) => {
    if (!isNaN(discount.discountValue) && typeof discount.discountValue === 'number') {
        const discountedPrice = price * (100 - Math.min(100, discount.discountValue));
        return discountedPrice >= 0 ? discountedPrice / 100 : price;
    }
    return price;
};
const getDefaultResult = ({ price, quantity }) => {
    const result = {};
    if (price !== undefined) {
        result.price = price;
        if (quantity === undefined)
            result.totalPrice = price;
        else
            result.totalPrice = price * quantity;
    }
    if (quantity !== undefined)
        result.quantity = quantity;
    return result;
};
const priceMgrCompute = ({ price, quantity, discount, discountQuantity = 0, effectiveDiscountQtyLimit = 0, isMenu, vatRatePerMille, }) => {
    var _a, _b;
    const combinatorDiscounts = ['familyDiscount'];
    if (!discount || combinatorDiscounts.includes(discount.discountType)) {
        return getDefaultResult({ price, quantity, discount });
    }
    if (typeof price !== 'number' || !Number.isFinite(price)) {
        return getDefaultResult({ price, quantity, discount });
    }
    if (discount.discountType === DISCOUNT_TYPE.simpleDiscountFixedAmount) {
        const discountedPrice = calculateSimpleDiscountFixedAmount({
            price,
            quantity,
            discount,
            isMenu,
        });
        const priceBefore = price;
        if (discountedPrice !== priceBefore) {
            let totalPrice = discountedPrice * quantity;
            if (((effectiveDiscountQtyLimit || ((_a = discount === null || discount === void 0 ? void 0 : discount.options) === null || _a === void 0 ? void 0 : _a.quantityLimit)) &&
                discountQuantity >= 0 &&
                quantity > discountQuantity) ||
                (discountQuantity > 0 && quantity > discountQuantity)) {
                totalPrice = discountedPrice * discountQuantity + priceBefore * (quantity - discountQuantity);
            }
            return Object.assign({ price: discountedPrice, priceBefore: priceBefore, totalPrice: totalPrice, totalPriceBefore: priceBefore * quantity, discountQuantity: discountQuantity }, (vatRatePerMille && { totalVat: calculateVat(vatRatePerMille, totalPrice) }));
        }
        return getDefaultResult({ price, quantity, discount });
    }
    if (discount.discountType === DISCOUNT_TYPE.percentDiscount) {
        const discountedPrice = calculatePercentDiscountAmount({
            price,
            quantity,
            discount,
        });
        const priceBefore = price;
        if (discountedPrice !== priceBefore) {
            let totalPrice = discountedPrice * quantity;
            if (((effectiveDiscountQtyLimit || ((_b = discount === null || discount === void 0 ? void 0 : discount.options) === null || _b === void 0 ? void 0 : _b.quantityLimit)) &&
                discountQuantity >= 0 &&
                quantity > discountQuantity) ||
                (discountQuantity > 0 && quantity > discountQuantity)) {
                totalPrice = discountedPrice * discountQuantity + priceBefore * (quantity - discountQuantity);
            }
            return {
                price: discountedPrice,
                priceBefore: priceBefore,
                totalPrice: totalPrice,
                totalPriceBefore: priceBefore * quantity,
                discountQuantity: discountQuantity,
                discount: discount,
            };
        }
        return getDefaultResult({ price, quantity, discount });
    }
    if (discount.discountType === DISCOUNT_TYPE.twoForOne) {
        return getDefaultResult({ price, quantity, discount });
    }
    throw new Error('NotImplementedYet');
};
const DISCOUNT_TYPE = {
    simpleDiscountFixedAmount: 'simpleDiscountFixedAmount',
    percentDiscount: 'percentDiscount',
    twoForOne: 'twoForOne',
    familyDiscount: 'familyDiscount',
    bulkDiscount: 'bulkDiscount',
};
const PriceMgr = {
    DISCOUNT_TYPE,
    compute: priceMgrCompute,
};
export { PriceMgr };
export { DiscountScopeNew as DiscountScope };
